import {
    IMPORT_STEP_1,
    IMPORT_STEP_2,
    IMPORT_STEP_3,
    IMPORT_STEP_4,
    IMPORT_STEP_5,
    IMPORT_STEP_CANCELED,
    IMPORT_STEP_FAILED,
    useImportContext
} from "v4/pages/admin/Import/contexts/ImportContext";
import CreateImport from "v4/pages/admin/Import/components/ImportSteps/components/CreateImport/CreateImport";
import MapImport from "v4/pages/admin/Import/components/ImportSteps/components/MapImport/MapImport";
import React, {useEffect} from "react";
import {useParams} from "react-router-dom";
import useFetch from "v4/hooks/useFetch";
import {generateUrl} from "v4/services/api.service";
import {IMPORT_INFOS} from "v4/data/apiRoutes";
import useToggle from "v4/hooks/useToggle";
import CompletedImport from "v4/pages/admin/Import/components/ImportSteps/components/CompletedImport/CompletedImport";
import FailedImport from "v4/pages/admin/Import/components/ImportSteps/components/FailedImport/FailedImport";
import CanceledImport from "v4/pages/admin/Import/components/ImportSteps/components/CanceledImport/CanceledImport";
import useImportRedirect from "v4/pages/admin/Import/components/ImportSteps/hooks/useImportRedirect";
import ValidateAndProcessImport
    from "v4/pages/admin/Import/components/ImportSteps/components/ValidateAndProcessImport/ValidateAndProcessImport";

const importSteps = {
    [IMPORT_STEP_1]: {
        component: () => <CreateImport/>
    },
    [IMPORT_STEP_2]: {
        component: () => <MapImport/>
    },
    [IMPORT_STEP_3]: {
        component: () => <ValidateAndProcessImport/>
    },
    [IMPORT_STEP_4]: {
        component: () => <ValidateAndProcessImport isProcessing/>
    },
    [IMPORT_STEP_5]: {
        component: () => <CompletedImport/>
    },
    [IMPORT_STEP_FAILED]: {
        component: () => <FailedImport/>
    },
    [IMPORT_STEP_CANCELED]: {
        component: () => <CanceledImport/>
    },
}

export default function useImportSteps() {
    const {currentStep} = useImportContext();
    const {id: importId} = useParams();
    const [{data, isFinished}, fetchImportInfos] = useFetch();
    const importInfos = data?.import;
    const [isImportInfosLoading, toggleIsImportInfosLoading] = useToggle(currentStep !== IMPORT_STEP_1 && !importInfos);

    useEffect(() => {
        if (importId) {
            fetchImportInfos({
                url: generateUrl(IMPORT_INFOS, {id: importId}),
            });
        }
        // eslint-disable-next-line
    }, [fetchImportInfos]);

    useEffect(() => {
        if (isFinished) {
            toggleIsImportInfosLoading(false);
        }
    }, [isFinished, toggleIsImportInfosLoading]);

    useImportRedirect(data?.import.state);

    return {
        importSteps,
        currentStep,
        isImportInfosLoading,
    }
}
